module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "关联奖品",
      "visible": _vm.visible,
      "close-on-click-modal": false,
      "show-close": false,
      "modal-append-to-body": false,
      "width": "920px"
    },
    on: {
      "close": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "prize-search-row"
  }, [_c('span', {
    staticClass: "search-label"
  }, [_vm._v("奖品名称")]), _vm._v(" "), _c('el-input', {
    staticClass: "prize-search-input",
    attrs: {
      "placeholder": "模糊搜索"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onSearch.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.prizeSearchText),
      callback: function($$v) {
        _vm.prizeSearchText = $$v
      },
      expression: "prizeSearchText"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.onSearch
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('span', {
    staticClass: "prize-selected-tip"
  }, [_vm._v("\n      已选 "), _c('b', [_vm._v(_vm._s(_vm.selectedPrizeIds.length))]), _vm._v(" / 10\n      "), (_vm.selectedPrizeIds.length >= 10) ? _c('span', {
    staticClass: "prize-limit-warn"
  }, [_vm._v("（已达上限）")]) : _vm._e()])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "prizeTable",
    staticClass: "prize-table",
    attrs: {
      "data": _vm.prizeList,
      "border": ""
    },
    on: {
      "selection-change": _vm.onSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "prizeId",
      "label": "奖品ID",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "prizeName",
      "label": "奖品名称",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "prizeType",
      "label": "奖品类型",
      "width": "110",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(_vm.getPrizeTypeLabel(scope.row.prizeType)) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "奖品详情",
      "min-width": "200",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.detailType === 'multiImage') ? _c('div', {
          staticClass: "detail-multi-img"
        }, _vm._l((scope.row.detail), function(img, idx) {
          return _c('img', {
            key: idx,
            staticClass: "detail-img-small",
            attrs: {
              "src": img
            }
          })
        }), 0) : (scope.row.detailType === 'image') ? _c('img', {
          staticClass: "detail-img",
          attrs: {
            "src": scope.row.detail
          }
        }) : _c('span', {
          staticClass: "detail-text"
        }, [_vm._v(_vm._s(scope.row.detail || '–'))])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "prize-pagination-row"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.pageNum,
      "page-sizes": [10, 20, 50],
      "page-size": _vm.pageSize,
      "total": _vm.total,
      "layout": "total, sizes, prev, pager, next"
    },
    on: {
      "current-change": _vm.onPageChange,
      "size-change": _vm.onSizeChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("确认")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-75304f84!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/onlineMatch/PrizeSelectDialog.vue
// module id = 1077
// module chunks = 0